/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ContactsStatuses } from 'apis'

export const isClanzyUser = (contact) => !!contact && !!contact.userId

export const isOnline = (contact) => !!contact && contact.status === ContactsStatuses.online
